const { getVisibilityValue, isInViewport } = require('../../src/deliEventUtils');
const { initGlobalWindowEbayObject } = require('../../src/utils');

const EVENTS = ['DOMContentLoaded', 'load', 'resize', 'scroll'];
module.exports = class {
    onCreate(input) {
        this.state = {
            placementId: input.placementId,
            lazyDivId: `lazyModule${input.placementId}`, // to find if div is in viewport
            module: input.module, // response from deli
            content: undefined, // Is set, when the event is fired and content is received
            visibilityValue: null,
        };
        this.eventHandler = this.eventHandler.bind(this);
    }

    onInput(input) {
        if (this.state.module !== input.module) {
            this.state.module = input.module;
            this.beginRendering();
        }
    }

    onMount() {
        initGlobalWindowEbayObject();
        this.beginRendering();
    }

    beginRendering() {
        try {
            const { module } = this.state;

            this.state.visibilityValue = getVisibilityValue(module);

            if (
                module &&
                module.callback &&
                module.callback.url &&
                module.callback.method &&
                module.callback.body
            ) {
                EVENTS.forEach(eventName => {
                    document.addEventListener(eventName, this.eventHandler, false);
                });
            } else {
                throw new Error('No Callback URL or Method or Body received');
            }
        } catch (err) {
            // All errors from this file on client side, are bubbled up here
            console.error(err);
        }
    }

    onDestroy() {
        EVENTS.forEach(eventName => {
            document.removeEventListener(eventName, this.eventHandler, false);
        });
    }

    /**
     *
     * @returns a Global object located from window.ebay.ads.lazy:
     * eg: window.ebay.ads.lazy = {
     *       '1': {}
     *     };
     * Can return undefined if there's no element present at the global location
     */
    globalRegisteredPlacement() {
        return window.ebay.ads.lazy[this.state.placementId];
    }

    eventHandler() {
        const lazyDiv = document.getElementById(this.state.lazyDivId);

        // Skip if the element is not in viewport
        if (!isInViewport(lazyDiv, this.state.visibilityValue)) {
            return;
        }

        const globalRegisteredPlacement = this.globalRegisteredPlacement();

        // Fetch content if not started yet
        if (!globalRegisteredPlacement) {
            // Fetch is about to start. event listerners finished their tasks, so remove them
            EVENTS.forEach(eventName => {
                document.removeEventListener(eventName, this.eventHandler, false);
            });

            this.fetchContent();
            return;
        }

        // Content is already fetched
        if (Object.keys(globalRegisteredPlacement).length !== 0) {
            this.state.content = globalRegisteredPlacement;
            return;
        }

        // Listener for content received by other component
        document.addEventListener(`lazyModuleResponseReceived:${this.state.placementId}`, (data) => {
            this.state.content = data.detail;
        }, { once: true });
    }

    fetchContent() {
        const { module: { callback } } = this.state;

        if (!callback) {
            return;
        }

        const { url, headers, body } = callback;

        // If current placement Id is not getting processed/not put in the queue yet
        if (!this.globalRegisteredPlacement()) {
            if (
                body &&
                body.impressions &&
                Array.isArray(body.impressions)
            ) {
                body.impressions.forEach(impression => {
                    if (
                        impression.container &&
                        impression.container.id &&
                        !window.ebay.ads.lazy[impression.container.id]
                    ) {
                        window.ebay.ads.lazy[impression.container.id] = {};
                    }
                });
            }
        }

        fetch(url, {
            method: 'POST',
            headers: Object.assign(
                { 'Content-Type': 'application/json' },
                headers
            ),
            body: JSON.stringify(body),
        }).then((response) => {
            if (response.status && response.status === 200) {
                return response.json();
            }
            throw new Error(`Error in fetching Lazy module content. Status: ${response.status}`);
        })
            .then((res) => {
                if (res && res.modules) {
                    Object.keys(res.modules)
                        .filter((key) => key.indexOf('PLACEMENT_') !== -1)
                        .forEach((PLACEMENT_PLACEMENTID) => {
                            const regexp = /.*?PLACEMENT_(\d+)/;
                            const regexpRes = regexp.exec(PLACEMENT_PLACEMENTID);
                            if (regexpRes !== null && regexpRes[1]) {
                                const placementId = parseInt(regexpRes[1], 10);
                                const content = res.modules[PLACEMENT_PLACEMENTID];

                                window.ebay.ads.lazy[placementId] = content;

                                if (placementId === this.state.placementId) {
                                    this.state.content = content;
                                }

                                document.dispatchEvent(
                                    new CustomEvent(`lazyModuleResponseReceived:${placementId}`, {
                                        detail: content,
                                    })
                                );
                            } else {
                                throw new Error(`Error in data received, ${Object.keys(res.modules)}`);
                            }
                        });
                }
            })
            .catch((error) => {
                throw error;
            });
    }
};
